import {Inject, Injectable} from '@angular/core';
import {JwtHelperService} from '@auth0/angular-jwt';
import {Observable} from 'rxjs/Observable';
import {HttpClient} from '@angular/common/http';
import {Login, Token} from '../models';
import 'rxjs/add/operator/map';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class AuthService {
  constructor(public jwtHelper: JwtHelperService, @Inject('BASE_URL') private baseUrl: string, private http: HttpClient) {
  }

  private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  get isAuth(): Observable<boolean> {
      this.loggedIn.next(this.isAuthenticated());
      return this.loggedIn.asObservable();
  }

    isAuthenticated(): boolean {
    const token = localStorage.getItem('token');
    let isAuth = false;

    // Check whether the token is expired and return
    // true or false
    try {
      isAuth = !this.jwtHelper.isTokenExpired(token);
      this.loggedIn.next(isAuth);
    }
    finally {
      return isAuth;
    }
  }

  getAuthorizationHeader(): string {
    return 'Bearer ' + localStorage.getItem('token');
  }

  public login(user: Login) {
    const request = this.http.post<Token>(this.baseUrl + '/api/token', JSON.stringify(user));
    request.subscribe(
      token => {
        if (token && token.token) {
          localStorage.setItem('token', token.token);
          const isAuth = this.isAuthenticated();
        }
      });
    return request;
  }
}



// WEBPACK FOOTER //
// ./src/components/app/infrastructure/services/auth.service.ts